var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0_2083_409)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2083_409",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2083_409",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2083_409",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEp0lEQVR4nO2dv28cRRTHJ0G2b94Zwo8GBMiS740DF2IKi18FFAhaaLxAbt7ZojmhSPwNToFAiCKBjgIJBBUF1EiIAjoqKhIZGhA/JJDCDyOIopCgObvwrs8/bmfGfsd+P9IWkc5vd+eTmTe7M9pnDAAAAAAAAABMAkuDKct+2Tr/gWW5SOz/Iic3Gn2wbIS22GwTvxza6FBc2E7vWXKyfuQN4NQf66GtMqpYO26dvKbgRm9M0HHdsn81tF1yHZAhtcVsSkk/TF0vn8j/Q07OW3fmYbMobdN0FqUd2oKcXNhqm3JP6fhn0pxoaTC1M2f479rz8kCaE/z/aJ/snSYn31dzSpJEH2YM1Z4BGQeV4q9Uhq5lE0uYxlVMn48O2hCI/ZslIU7ejw5qWS6Vgi74h5JcbQOwTh4p9xC5FB00PPBsD2q6xWySq20C3WK2NLqwbETHrE7hklxog6DU7QchcUCIMiBEGRCiDAhRBoQoA0KUASG7cU9hLfcLYv82sXxpnf+F2F8lJ9esk8vhhSmx/8I6ecdy/yVy8qAxxU0mEgipcNt8ccKyvLLZ6GOuZQzfUvgPg0gzt9oyNYCQbbRZniaWH1Os/lmWX4llzYwJhGxBTgZhOEq9LGvGBEKMMa2Of46c/3fnEOR/CCt6bdd/aoZXOsOVzm4xffN9/TvCv9sL8qRlf9ayvLv1WwiJxbqVu62T3ysiroY8EhL7OLFanf5j6CGREPuPK414reXkhdrxMGTVp+X84yN2fJyNCAkhMYQl0sq09XNjzLGYmOghNTkxt3orOfl7ewOGJG0igZCahH1Pld0x3x6od3SLaWJ5kVg+Gm53qixZQ0hNwiyq0ngX9vubWde/n5z/Bs8hGbBOPikNV9zrHeCVyk94MMyEZf91SUhn5dSev3f+HJ7UM2Kd/7nUwHOrd+75e/ZfVabH77Vc74lW5/l7zV0DSnVdjX11QpVtm4Zfnhlrv1mmDeMNFiJjXedh3ReEOAhRAaGH6IIgREfDU80n6roLVGGtJeZ6o24+S8AJFzITFrYirjfq5rMEnGAh1snlcd8eQ4jLKITl03FkNFKIyYhl/0a5h/jXx40BIQmxTj6LSegBCEnHMev8bzEJPQAhiZieP+NiE3oAQhIRdqrEJvQAhChK6I0UQof0HFInoY86T62bzhpwQoXM1Ejoo85T66azBpxAIbZmQh91nlo3nTXgJArhegl91HnqxskXMBMUKUTLdR1+wEwQhOiCIEQXBCG6IAjRBUGILghCdEEQoguCEF0QhOiCIEQXBCG6IAjRBUGILghCdEEQoguCEF0QhOiCIEQXBCG6IAjRBTVFiGX/5yQUdCGFQm5nf0tlf9cf6UsehTJ5CiGFQiz7R5OXPBpRFGzfzx4dBaRQCLG8laEo2IiyeSd7p40ySJmQ8KnyLGXzdi0sqUwKKRLSXlhZzFZYco/Sq1dCnb4wTmpI9HTUQrrF7DBnDIepcs9IW3p1CxQnFj3FiTdZOx4C7+wpOOgoyndXvv6JAvdu3/+I68mHqV1ZGkyFGUOYEluWi/t9WrURB8tG+O5jmNoOZ1OpEjgAAAAAAAAAmLz8B1Q8wC9moxUJAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.583a22bd5b5f454357de531a71f32f68.svg";
export { ForwardRef as ReactComponent };